import React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Stack,
  Typography,
  Button,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useNavigate } from "react-router-dom";
import { JobsAccordion } from "../../../shared-components/JobsAccordion";

const ACTIVE_JOB_STATUSES = ["pending", "in_progress", "in progress"];

const LinkedQuizGroups = ({ assignment, onRefresh = null }) => {
  const navigate = useNavigate();

  if (!assignment.linkedQuizGroups?.length) return null;

  const hasActiveJobs = assignment.linkedQuizGroups.some((quizGroup) =>
    (quizGroup.ongoingJobs || []).some((job) =>
      ACTIVE_JOB_STATUSES.includes(job.status?.toLowerCase()),
    ),
  );

  return (
    <Accordion sx={{ mt: 2 }} defaultExpanded={hasActiveJobs}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography fontWeight="bold">
          Linked Quizzes ({assignment.linkedQuizGroups.length})
        </Typography>
      </AccordionSummary>

      <AccordionDetails>
        <Stack spacing={1}>
          {assignment.linkedQuizGroups.map((quizGroup) => (
            <Stack key={quizGroup.id} spacing={1}>
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                sx={{
                  p: 1,
                  borderRadius: 1,
                  bgcolor: "background.default",
                }}
              >
                <Typography>
                  <strong>Name:</strong> {quizGroup.name}
                </Typography>

                <Button
                  size="small"
                  variant="outlined"
                  onClick={() => navigate(`/quizzes/view/${quizGroup.id}`)}
                >
                  View Quiz
                </Button>
              </Stack>
              <JobsAccordion
                jobs={quizGroup.ongoingJobs || []}
                onRefresh={onRefresh}
              />
            </Stack>
          ))}
        </Stack>
      </AccordionDetails>
    </Accordion>
  );
};

export default LinkedQuizGroups;
